import { Autocomplete, FormControl, FormHelperText, TextField } from '@coolblue-development/becky';
import { RoutingProfile } from '../../../../models/RoutingProfiles';

interface RoutingProfileSelectorProps {
  selectedRoutingProfile: string;
  onRoutingProfileChange: (value: string) => void;
  routingProfiles: RoutingProfile[];
  hasError: boolean;
  isDisabled: boolean;
  errorMessage?: string;
}

export const RoutingProfileSelector = ({
  selectedRoutingProfile,
  onRoutingProfileChange,
  routingProfiles,
  hasError,
  isDisabled,
  errorMessage
}: RoutingProfileSelectorProps): JSX.Element => {
  const selectedValue = routingProfiles.find(profile => profile.id === selectedRoutingProfile);

  return (
    <FormControl sx={{ marginTop: 2, width: '100%' }}>
      <Autocomplete<RoutingProfile>
        options={routingProfiles}
        value={selectedValue ?? null}
        onChange={(_, value) => {
          if (value) {
            onRoutingProfileChange(value.id);
          } else {
            onRoutingProfileChange('');
          }
        }}
        getOptionLabel={option => (option ? option.name : '')}
        getOptionKey={option => option.id}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        disabled={isDisabled}
        renderInput={params => (
          <TextField {...params} placeholder="Select or search a routing profile" error={hasError} />
        )}
        sx={{ width: '100%' }}
      />
      {hasError && errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
    </FormControl>
  );
};
